import type { User } from "@/entities/user";

export enum ManagerStatus {
  ALIVE = "alive",
  DEAD = "dead",
  BANNED = "banned",
}

export interface Manager {
  _id: string;
  curators: string[];
  curatorsCount: number;
  status: ManagerStatus;
  teamlead: string;
  userId: User;
  createdAt: Date;
  updatedAt: Date;
}

export interface ManagerV2 {
  userId: string;
  username: string;
  userIsBanned: boolean;
  totalAssignedLeadsCount: number;
  currentAssignedLeadsCount: number;
  totalConvertedLeadsCount: number;
  currentAssignedCuratorsCount: number;
  teamleadId: string;
  teamleadUsername: string;
  masterTeamleadId: string;
  masterTeamleadUsername: string;
  createdAt: Date;
  updatedAt: Date;
}
